customElements.define('custom-edit-account-form', class extends HTMLElement {
  submitData = {};
  constructor() {
    super();
    this.mobileNo = this.querySelector("#EditAccountPhoneNumber");
    this.email = this.querySelector("#EditAccountEmail");
    this.subscribeEmail = this.querySelector("#EditAccountSubscribeEmail");
    this.subscribeSMS = this.querySelector("#EditAccountSubscribeSMS");

    this.querySelector(`form button[type="button"]`)?.addEventListener('click', (e) => {
      const formValidate = this.handleProcessForm();
      if (formValidate.type !== "success") return;
      const formData = new FormData(this.querySelector('form'));
      const obj = {};
      for (const [name, value] of formData) {
        obj[name] = value;
      }
      const birthDayStr = obj.birthDay ?? `${obj["birthday-day"]}/${obj["birthday-month"]}/${obj["birthday-year"]}`;
      let birthDayArr = birthDayStr.split('/').reverse().map(item => item.padStart(2, '0'));
      this.submitData.emailYN = obj.subscribe_email === 'email' ? 'Y' : 'N';
      this.submitData.smsYN = obj.subscribe_sms === 'sms' ? 'Y' : 'N';
      this.submitData.sex = obj.gender === 'Nam' || obj.gender === "Male" ? 'M' : 'F';
      this.submitData.birthDay = birthDayArr.join("");
      this.submitData.uid = this.dataset.customerId;
      this.submitData.firstName = obj.first_name;
      this.submitData.lastName = obj.last_name;
      this.submitData.metafields = [];
      ["sex", "birthDay"].forEach(item => {
        this.submitData.metafields.push({
          namespace: "customer",
          key: item,
          value: this.submitData[item]
        })
      })
      this.handleSubmitForm(this.submitData)
    })

  }

  connectedCallback() {
    this.handleFetchInitData();
  }

  handleProcessForm() {
    let type = 'success';
    const requiredFields = this.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      const ancestorNode = field.closest('[id^="FormField-"]');
      const errorField = ancestorNode.querySelector('.form-field__text--error');
      if (
        (field.type === "radio" && this.querySelectorAll(`input[name="${field.name}"]:checked`).length === 0) ||
        (field.type !== "radio" && !field.value)
      ) {
        errorField?.classList?.remove('hidden');
        type = 'error';
      } else {
        errorField?.classList?.add('hidden');
      }
    })
    return { type }
  }

  async handleFetchInitData() {
    if (!this.mobileNo?.value) return;
    const url = globalThis.middlewareUrls?.memberCheck;
    if (!url) return;
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          mobileNo: this.mobileNo?.value,
          email: this.email?.value,
        })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();
      const data = resJson.data.data.customerInfo;
      const initData = { ...data, mobileNo: data.mobileNo.replace(/^0/, globalThis.phonePrefix || '') };
      delete initData.cstmGradeCD
      delete initData.cstmGradeNM;
      delete initData.empID;
      delete initData.mgm;
      this.handleSetInitData(initData)
    } catch (error) {
      console.error(error.message);
    }
  }

  handleSetInitData(data = {}) {
    this.submitData = data;
    const gender = data.sex;
    if (gender) {
      this.querySelector(".form-field--gender").innerHTML = `
        <label class="form-field__label" for="EditAccountGender">Giới tính *</label>
        <div class="form-field__wrapper">
          <input
            type="text"
            class="form-field__input"
            id="EditAccountGender"
            name="gender"
            value="${gender === 'F' ? 'Nữ' : 'Nam'}"
            readonly="readonly"
          >
        </div>
      `
    }
    if (data.birthDay) {
      const currentNode = this.querySelector("fieldset");
      const newNode = document.createElement('div');
      newNode.classList.add('form-field');
      newNode.id = "FormField-editAccountBirthday";
      const date = new Date(`${data.birthDay.slice(0, 4)}-${data.birthDay.slice(4, 6)}-${data.birthDay.slice(6, 8)}`);
      const formatted = new Intl.DateTimeFormat('en-US').format(date);
      newNode.innerHTML = `
        <label class="form-field__label" for="EditAccountBirthday">Date of birth *</label>
        <div class="form-field__wrapper">
          <input
            type="text"
            class="form-field__input"
            id="EditAccountBirthday"
            name="birthDay"
            value="${formatted}"
            readonly="readonly"
          >
        </div>
      `
      currentNode.replaceWith(newNode);
    }
    this.subscribeEmail.checked = data.emailYN === "Y";
    this.subscribeSMS.checked = data.smsYN === "Y";
    this.querySelector('.loading-mask')?.remove();
    this.querySelector('form').classList.remove('custom-visually-hidden')
  }

  async handleSubmitForm(data) {
    const loadingBtn = this.querySelector('button[type="button"] .loading__spinner');
    loadingBtn.classList.remove('hidden');
    const url = globalThis.middlewareUrls?.memberUpdate;
    if (!url) {
      loadingBtn?.classList.add('hidden');
      return;
    }
    try {
      const resSubmit = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      if (!resSubmit.ok) {
        throw new Error(`Response status: ${resSubmit.status}`);
      }

      const resJson = await resSubmit.json();

      const resData = resJson.data;
      if (resData) {
        globalThis.location.reload();
      }
    } catch (e) {
      console.error(e)
    } finally {
      loadingBtn.classList.add('hidden');
    }
  }
})